import React from 'react';
import WhatsAppIcon from '../WhatsAppIcon/WhatsAppIcon';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  return (
    <a
      href='https://wa.me/5512992418258'
      target='_blank'
      rel='noopener noreferrer'
      className='whatsapp-float'
      aria-label='Fale conosco pelo WhatsApp'
    >
      <WhatsAppIcon size={30} />
    </a>
  );
};

export default WhatsAppFloat;
